module.exports = __webpack_public_path__ + "img/typehoon50_1.d2c9bec1.jpg";